export default __webpack_public_path__ + "static/media/stem-the-holistic-way.2f3540d7.jpg";